import script from "./ConsoleHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./ConsoleHeader.vue?vue&type=script&lang=ts&setup=true"

import "./ConsoleHeader.vue?vue&type=style&index=0&id=2e5b3269&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e5b3269"]])

export default __exports__